import {
  Component,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Optional,
  SimpleChanges,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Types } from 'mongoose';

import { SAAS_SUBSCRIPTION_METHODS } from '@shared/constants';
import { ISaaSSubscriptions } from '@shared/interfaces';

import { CurrenciesResponseDTO } from '../../../../setup/currencies/services/currencies.service';
import { SaaSSubscriptionGeneralService } from '../../../services/subscription.general.services';

@Component({
  selector: 'app-user-view-popup',
  templateUrl: './user-view-popup.component.html',
  styleUrls: ['./user-view-popup.component.scss'],
})
export class UserViewPopupComponent implements OnInit, OnChanges {
  @Input() plan: ISaaSSubscriptions;
  @Input() currenciesList: CurrenciesResponseDTO[] = [];

  features: { name: string; icon: string }[] = [];
  planDetails: string = null;
  priceDetails: string = null;
  isPopup = false;

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    private readonly data: {
      plan: ISaaSSubscriptions;
      currencies: CurrenciesResponseDTO[];
    },
    private readonly translate: TranslateService,
    private readonly saaSSubscriptionGeneralService: SaaSSubscriptionGeneralService
  ) {
    if (data) {
      this.plan = data.plan;
      this.currenciesList = data.currencies;
      this.isPopup = true;
    }
  }

  getCurrencyCode(baseCurrency: string | Types.ObjectId) {
    return this.currenciesList.find(
      (c) => c?._id.toString() === baseCurrency?.toString()
    )?.code;
  }

  ngOnInit() {
    this.updatePlanDetails();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['plan'] || changes['currenciesList']) {
      this.updatePlanDetails();
    }
  }

  private updatePlanDetails() {
    if (this.plan) {
      this.features = this.plan.features
        .filter((feature) => feature.is_displayable)
        .map((_e) => ({ icon: _e.icon, name: _e.title }));

      if (this.plan.method === SAAS_SUBSCRIPTION_METHODS.PAYABLE) {
        this.planDetails = ` ${this.translate.instant(
          this.saaSSubscriptionGeneralService.getPaymentTypeDisplayValue(
            this.plan.payment_type
          )
        )}/${this.translate.instant(
          this.saaSSubscriptionGeneralService.getModeMethodDisplayValue(
            this.plan.duration_mode
          )
        )}`;
        this.priceDetails = `${this.getCurrencyCode(
          this.plan.price_currency
        )} ${this.plan.price}`;
      } else {
        this.planDetails = this.translate.instant('SUBSCRIPTION');
      }
    }
  }
}
